import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb54a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "select-card-ques" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tile-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.inputDivId,
    class: "bubble-tile comp-start"
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.message), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, itemIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: itemIndex,
        class: _normalizeClass(["col-md-4 col-xs-12 select-tile select-band", [
        item.isSelected ? 'selected-tile' : '',
        _ctx.isTouchDevice ? '' : item.isSelected ? '' : 'hoverClass',
      ]]),
        onClick: ($event: any) => (_ctx.onSelectItem(itemIndex))
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(item.staffRange), 1)
      ], 10, _hoisted_3))
    }), 128))
  ], 8, _hoisted_1))
}